import * as React from 'react'
import './DefinitionInput.css'

import Tooltip from 'rc-tooltip'
import 'rc-tooltip/assets/bootstrap_white.css';
import './tooltip.css'

import * as _ from 'lodash'
import classNames from 'classnames'
// import { ObjectInspector } from 'react-inspector'


import Block from "./Block"
import Steps from "./Steps"
import Node from "./Node"
import NodeBox from "./NodeBox"
import NodeValue from "./NodeValue"
import EditableText from "./EditableText"
import WithContextMenu from "./WithContextMenu"


import { newId } from '../lib/id'
// import { evaluateSteps, runCodeToResult } from '../evaluate'
import * as actions from '../actions'
import { standardSCU, arrRemove } from '../util'
import { NetworkUser } from 'golgi'
import { Cursor, CursorV } from '../lib/Cursor'
import { Stack } from '../types/stack';

import * as Model from '../types/document'
import { runCodeToResult } from 'src/model/run';
import MyCodeMirror from 'src/view/MyCodeMirror';

class DefinitionInput extends React.Component<{
  inputC: Cursor<Model.DefinitionInput>,
  definitionC: Cursor<Model.Definition>,
  stack: Stack,
}> {

  state = { settingsExpanded: false }
  ref = React.createRef<HTMLDivElement>()

  render() {
    return <NetworkUser debugName="DefinitionInput" props={this.props} state={this.state} render={() => {
      const {inputC, definitionC, stack} = this.props
      const {settingsExpanded} = this.state

      const activeSetting = inputC._('activeSetting').get()

      return (
        <WithContextMenu
          menuMaker = {() => [{
            type: 'heading',
            heading: "INPUT"
          }, {
            type: 'contents',
            contents: "Delete input",
            onClick: () => actions.act(() => {
              definitionC.select('inputs').update((inputs) => _.without(inputs, inputC.get()))
            })
          }]}>
          <div className="DefinitionInput" ref={this.ref}>
            <Node nodeId={inputC.get().id} blockC={definitionC} stack={stack}
                  onClick={() => this.setState({settingsExpanded: true})} />
            {settingsExpanded && <React.Fragment>
              {inputC._('settings').fetch().call(CursorV.elems).map((settingC, i) =>
                <div key={i} style={{opacity: i === activeSetting ? 1 : 0.5}}>
                  <NodeBox
                      divProps={{
                        onMouseDown: () => actions.act(() => {
                          inputC._('activeSetting').set(i)
                        })
                      }}>
                    <MyCodeMirror
                        value={settingC.value()}
                        onValue={(value: string) => {actions.act(() =>
                          settingC.set(value)
                        )}} />
                  </NodeBox>
                </div>
              )}
              <button className="DefinitionInput-new-setting" style={{width: 20, height: 20, flex: "0 0 auto"}}
                  onClick={() => actions.act(() => {
                    inputC._('settings').update((settings) => [...settings, ""])
                  })}>
                  +
              </button>
            </React.Fragment>}
          </div>
        </WithContextMenu>
      )
    }} />
  }

  componentDidMount() {
    window.document.addEventListener('mousedown', this.onDocumentMouseDown);
  }

  componentWillUnmount() {
    window.document.removeEventListener('mousedown', this.onDocumentMouseDown);
  }

  onDocumentMouseDown = (event: MouseEvent) => {
    if (this.state.settingsExpanded && !(this.ref.current && event.target && this.ref.current.contains(event.target as Node))) {
      this.setState({settingsExpanded: false})
    }
  }
}

export default DefinitionInput;



// WEBPACK FOOTER //
// ./src/view/DefinitionInput.tsx